module.exports = function() {
  return new Worker(__webpack_public_path__ + "3979ec874670e2f10fde.worker.js");
};


// WEBPACK FOOTER //
// ./src/AMILoader.worker/AMILoader.worker.js